@if (forgotPassword) {
  @if (isSuccess) {
    <div class="login-success">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <h1>Email Sent!</h1>
      <p>We have send password reset email to {{forgotPw.value.email}}, please check the email to reset the password..</p>
    </div>
  } @else {
    <form [formGroup]="forgotPw">
      <ion-label>Email address</ion-label>
    <ion-input fill="outline" mode="md"
               formControlName="email"
               placeholder="Email"></ion-input>
      <a (click)="changeForgotPassword()">Back to Login?</a>
      <div></div>
      <ion-button expand="block"
                  color="primary" (click)="sendPasswordResetEmail()">Send reset email</ion-button>
    </form>
  }
} @else {
  <div class="login-from-header">
    <span class="logo">
      <app-logo [isLogin]="true"></app-logo>
    </span>
    <h1>Log In</h1>
    <p>Don't have an account? <a [routerLink]="['/user/register']">Create account</a></p>
  </div>
  @if (!isSuccess) {
    <form [formGroup]="loginForm" (submit)="loginUser()">
      <ion-label>Email address</ion-label>
      <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                 fill="outline" mode="md"
                 formControlName="email"
                 placeholder="Email"></ion-input>

      <ion-label>Password</ion-label>
      <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                 fill="outline" mode="md"
                 formControlName="password"
                 type="password"
                 placeholder="Password"></ion-input>
      <a (click)="changeForgotPassword()">Forgot password?</a>
      <div></div>
      <ion-button expand="block"
                  color="primary" type="submit">Login</ion-button>
      <div class="sm-login">
        <div class="divider">
          <span>or Log In with</span>
        </div>
        <ion-button expand="block"
                    class="google-sign-in"
                    (click)="loginWithGoogle()">
          <ion-img src="./assets/google_g_icon.svg"></ion-img>
          Login with Google
        </ion-button>
      </div>
    </form>
  } @else {
    <div class="login-success">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <h1>Welcome back,</h1>
      <p>You have successfully logged in to your account.</p>
    </div>
  }
}
